import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

import Api from "../../../../lib/componentApi";
import getRestaurantsLink from "../../../../lib/getRestaurantsLink";
import getAppErrors from "../../../../lib/appErrors";
import getHeaderData from "../../../../lib/getHeaderData";
import getLocalData from "../../../../lib/getLocalData";

import CheckOut from "../../../../components/Restaurants/Products/CheckOut";
import CommonHeader from "../../../../components/Common/Header";
import AppErrors from "../../../../components/Common/AppErrors";
import { isMobile } from "react-device-detect";
import mixpanel from "../../../../lib/mixPanel";

var configs = require("../../../../../public/config");

class CheckOutProducts extends Component {
  constructor(props, context) {
    super(props, context);
    let userAddresses = [];
    let userId = null;
    let smsVerified = false;
    const staticContext = props.staticContext;
    const { initialData } = getHeaderData(staticContext, "user");
    if (initialData) {
      userAddresses = initialData.addresses;
      userId = initialData.uid;
      smsVerified = initialData.smsVerified;
    }
    this.state = {
      basketData: null,
      deleteItem: false,
      addAlsoAdded: false,
      useLocalePoints: false,
      addPromoCode: false,
      mobileNumber: null,
      loginSection: false,
      newAddress: false,
      points: 0,
      userId,
      orderUid: "",
      pointsEarned: 0,
      submitted: false,
      smsVerified,
      item: "",
      pointsAmount: 0,
      loading: true,
      selectedPayment: null,
      promo: {
        code: "",
        amount: "",
        type: ""
      },
      paymentSection: false,
      smsVerificationSection: false,
      errorMessage: null,
      userAddresses,
      errorCode: null,
      promoDesktop: false,
      pointsDesktop: false,
      payments: [],
      addNewPayment: false
    };
  }
  componentDidMount() {
    this.getData();
  }
  getData = () => {
    Api.get("/api/user/email", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log("code-checkout-user");
      } else {
        const { bucketPoints } = response;

        const usablePointsData =
          bucketPoints.find(
            bucket => bucket.bucketId === configs.localeBarExcludedBucketId
          ) || {};
        const bucketPoint = usablePointsData.points || 0;

        this.setState({
          userId: (response && response.uid && response.uid) || null,
          points: response.points,
          userAddresses: response.addresses,
          payments: response.creditCards || [],
          selectedPayment:
            (response.creditCards &&
              response.creditCards.length &&
              response.creditCards[0]) ||
            null,
          bucketPoint,
          smsVerified: response.smsVerified || false,
          mobileNumber: response.mobileNumber
        });
      }
    });
    this.getBasketData();
  };
  handleCloseError = (event, section, errorCode) => {
    event.preventDefault();
    this.setState(
      {
        [section]: false
      },
      () => {
        const errorMessage = getAppErrors(errorCode);
        this.setState({
          errorMessage:
            (errorMessage && errorMessage.message && errorMessage.message) ||
            null
        });
      }
    );
  };
  getBasketData = () => {
    let basketData = null;
    this.setState({
      loading: true
    });
    Api.get("/api/product/basket", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-basket-checkout");
      } else {
        basketData = response;
      }
      this.setState({ loading: false, basketData }, () => {
        if (basketData) {
          const { bucketPoint } = this.state;
          const { total, promoCode, deliveryFee } = basketData;
          let promoAmount = 0;
          if (promoCode) {
            if (promoCode.type === "FREE_DELIVERY") {
              if (deliveryFee) {
                promoAmount = parseFloat(deliveryFee);
              }
            } else if (promoCode.type === "PERCENT") {
              promoAmount = parseFloat(
                (parseFloat(total) * parseFloat(promoCode.amount)) / 100
              );
            } else {
              promoAmount = promoCode.amount || 0;
            }
          }
          const totalWithPromotion = parseFloat(
            parseFloat(total) - parseFloat(promoAmount)
          ).toFixed(2);
          let localPointDiscount = parseFloat(bucketPoint) * configs.ptsToGbp;
          if (localPointDiscount > parseFloat(totalWithPromotion)) {
            localPointDiscount = parseFloat(totalWithPromotion);
          }
          if (localPointDiscount) {
            this.setState({
              pointsDesktop: true,
              pointsAmount: localPointDiscount / configs.ptsToGbp
            });
          }
        }

        const { userAddresses, userId } = this.state;
        if (
          basketData &&
          userId &&
          (!basketData.address || !basketData.address.id) &&
          userAddresses.length
        ) {
          const localAddress = getLocalData("deliveryDetails") || {
            routeName: null,
            postalCode: null
          };
          const matchAddress = userAddresses.find(
            address =>
              address.addressLine1 === localAddress.routeName &&
              address.postalCode === localAddress.postalCode
          );
          if (matchAddress && matchAddress.id) {
            Api.post(
              "/api/product/set/address",
              { addressId: matchAddress.id },
              (response, errors) => {
                if (errors) {
                  if (errors === 503) {
                    this.setState(() => {
                      throw errors;
                    });
                  } else {
                    console.log(errors);
                  }
                } else if (response.code) {
                  console.log(response, "code-basket-set-address");
                } else {
                  if (response.status) {
                    this.getBasketData();
                  }
                }
              }
            );
          }
        }
      });
    });
  };

  closeWithoutSave = status => {
    this.setState({
      [status]: false
    });
  };
  closeDefaultStatus = async (status, response) => {
    var body = document.body;
    body.classList.remove("body-overflow");
    let stateKey, stateValues;
    if (response) {
      stateKey = await Object.keys(response)[0];
      stateValues = await Object.values(response)[0];
    }
    this.setState(
      {
        [stateKey]: stateValues,
        [status]: false
      },
      () => {
        if (
          status === "deleteItem" ||
          status === "addPromoCode" ||
          status === "newAddress"
        ) {
          this.getBasketData();
        } else if (
          status === "loginSection" ||
          status === "addNewPayment" ||
          status === "smsVerificationSection"
        ) {
          this.getData();
        }
        const { errorCode } = this.state;
        if (errorCode === 1822) {
          var body = document.body;
          body.classList.add("body-overflow");
          this.setState({
            newAddress: true
          });
        } else {
          this.setState({
            newAddress: false
          });
        }
      }
    );
  };
  getMobileChangedStatus = (section, item) => {
    var body = document.body;
    body.classList.add("body-overflow");
    Object.keys(this.state).map(key =>
      this.setState({
        [key]: this.state[key]
      })
    );
    this.setState({ [section]: !this.state[section], item });
  };
  handleChangeStatus = (event, section, item) => {
    event.preventDefault();
    if (section === "addPromoCode") {
      if (isMobile) {
        this.getMobileChangedStatus(section, item);
      } else {
        this.setState({
          promoDesktop: true
        });
      }
    } else if (section === "useLocalePoints") {
      if (isMobile) {
        this.getMobileChangedStatus(section, item);
      } else {
        this.setState({
          pointsDesktop: true
        });
      }
    } else {
      this.getMobileChangedStatus(section, item);
    }
  };
  handleRemovePromoCode = () => {
    Api.post("/api/unselect/promo/code", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (typeof response.code === "number") {
        if (response.code === 1001) {
          this.setState(
            {
              promo: {
                code: "",
                amount: 0,
                type: ""
              }
            },
            () => {
              this.getData();
            }
          );
        }
        const errorMessage = getAppErrors(response.code);
        this.setState({
          errorMessage:
            (errorMessage && errorMessage.message) || response.message
        });
      } else {
        this.setState(
          {
            promo: {
              code: "",
              amount: 0,
              type: ""
            }
          },
          () => {
            this.getData();
          }
        );
      }
    });
  };
  sendSmsVerificationKey = () => {
    Api.post("/api/send/sms/key", {}, (response, errors) => {
      var body = document.body;
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        const errorMessage = getAppErrors(response.code);
        let message =
          (errorMessage && errorMessage.message) || response.message;
        if (response.code === 2043) {
          const param = response.params[0] || 10;
          message = message.replace("[:par1]", param);
        }
        body.classList.add("body-overflow");
        this.setState({
          errorMessage: message,
          active: false,
          smsVerificationSection: false
        });
      } else {
        if (response.status) {
          this.setState({
            smsVerificationSection: true
          });
        }
      }
    });
  };
  checkConfirmable = () => {
    const { basketData, userId, smsVerified } = this.state;
    var body = document.body;
    if (!userId) {
      body.classList.add("body-overflow");
      this.setState({
        loginSection: true
      });
      return;
    } else if (!basketData.address || !basketData.address.id) {
      body.classList.add("body-overflow");
      this.setState({
        newAddress: true
      });
      return;
    } else if (!smsVerified) {
      body.classList.add("body-overflow");
      this.sendSmsVerificationKey();
    } else {
      return true;
    }
  };
  getNewBasket = () => {
    this.getData();
  };

  onConfirmBasket = confirmResponse => {
    if (confirmResponse && typeof confirmResponse.confirmBasket === "number") {
      if (isMobile) {
        var body = document.body;
        body.classList.add("body-overflow");
        this.setState({
          paymentSection: true
        });
      } else {
        const { selectedPayment, pointsAmount, basketData } = this.state;
        if (selectedPayment) {
          const data = {
            paymentSourceType: 1,
            paymentSourceToken: selectedPayment.uid,
            points: pointsAmount
          };
          this.setState({ loading: true });
          Api.post(
            "/api/product/checkout/complete",
            data,
            (response, errors) => {
              if (errors) {
                if (errors === 503) {
                  this.setState(() => {
                    throw errors;
                  });
                } else {
                  console.log(errors);
                }
              } else if (response.code) {
                const errorMessage = getAppErrors(response.code);
                this.setState({
                  errorMessage:
                    (errorMessage && errorMessage.message) || response.message
                });
              } else {
                if (response.status) {
                  localStorage.setItem("userCanRate", "true");
                  mixpanel.people.increment("Count of Purchases");
                  mixpanel.people.increment({
                    "Total Purchase": response.confirmBasket
                  });
                  mixpanel.people.set({ "Basket is empty": true });
                  mixpanel.people.set({
                    "Promo Applied": null
                  });
                  mixpanel.track("Order Checkout", {
                    _amount: confirmResponse.confirmBasket,
                    _restaurantName: basketData.restaurant.name,
                    _promotionCode: basketData.promoCode,
                    _paymentMethod:
                      (confirmResponse.confirmBasket && "Credit Card") ||
                      "Point",
                    _pointsUsed: basketData.usedPoints
                  });
                  if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                  } else {
                    this.setState({
                      submitted: true,
                      orderUid: response.orderUid,
                      pointsEarned: response.pointsEarned
                    });
                  }
                } else {
                  console.log(response);
                }
              }
              this.setState({ loading: false });
            }
          );
        } else {
          this.setState({ errorMessage: "Please select payment" });
        }
      }
    }
  };
  handleSelectNewPayment = () => {
    this.setState({
      addNewPayment: true
    });
  };
  onSelectPayment = payment => {
    this.setState({
      selectedPayment: payment
    });
  };
  closePromoDesktop = () => {
    this.setState({
      promoDesktop: false
    });
  };
  closePointDesktop = () => {
    this.setState({
      pointsDesktop: false
    });
  };
  renderSelectedPage = () => {
    const {
      basketData,
      addAlsoAdded,
      addPromoCode,
      deleteItem,
      useLocalePoints,
      item,
      promo,
      errorMessage,
      newAddress,
      loading,
      userAddresses,
      paymentSection,
      smsVerificationSection
    } = this.state;
    if (!basketData) {
      if (loading) {
        return <div />;
      }
      if (errorMessage) {
        return (
          <AppErrors
            message={errorMessage}
            onClickClose={() => this.closeDefaultStatus("errorMessage")}
          />
        );
      } else {
        const href = getRestaurantsLink();
        return (
          <React.Fragment>
            <Helmet>
              <title>Checkout</title>
              <meta property="og:title" content="Checkout" />
            </Helmet>
            <div className="container">
              <CommonHeader />
              <div className="white-bg empty-body empty-basket">
                <p>Your cart is empty.</p>
                <a
                  href={href}
                  className="btn btn-blue d-flex align-items-center justify-content-center"
                >
                  <icon className="icon icon-search" />{" "}
                  <span>Search somewhere else</span>
                </a>
              </div>
            </div>
          </React.Fragment>
        );
      }
    } else {
      const {
        points,
        userId,
        pointsAmount,
        loading,
        loginSection,
        mobileNumber,
        promoDesktop,
        pointsDesktop,
        payments,
        addNewPayment,
        orderUid,
        submitted,
        pointsEarned,
        selectedPayment
      } = this.state;
      let promoCode =
        (basketData &&
          basketData.promoCode &&
          basketData.promoCode.code && {
            code: basketData.promoCode.code,
            amount: basketData.promoCode.gainAmount,
            type: basketData.promoCode.gainType
          }) ||
        promo;
      return (
        <CheckOut
          basketData={basketData}
          mobileNumber={mobileNumber}
          points={points}
          handleChangeStatus={this.handleChangeStatus}
          removePromoCode={this.handleRemovePromoCode}
          promo={promoCode}
          pointsAmount={pointsAmount}
          paymentSection={paymentSection}
          loginSection={loginSection}
          getNewBasket={this.getNewBasket}
          userId={userId}
          userAddresses={userAddresses}
          onSelectPayment={this.onSelectPayment}
          selectedPayment={selectedPayment}
          onConfirmBasket={this.onConfirmBasket}
          checkConfirmable={this.checkConfirmable}
          parentError={errorMessage}
          onClickClose={() => this.closeDefaultStatus("errorMessage")}
          closeDefaultStatus={this.closeDefaultStatus}
          smsVerificationSection={smsVerificationSection}
          sendSmsVerificationKey={this.sendSmsVerificationKey}
          promoDesktop={promoDesktop}
          payments={payments}
          pointsDesktop={pointsDesktop}
          addNewPayment={addNewPayment}
          handleSelectNewPayment={this.handleSelectNewPayment}
          closePromoDesktop={this.closePromoDesktop}
          closePointDesktop={this.closePointDesktop}
          deliveryFee={
            (basketData && basketData.deliveryFee && basketData.deliveryFee) ||
            null
          }
          subTotal={
            (basketData && basketData.subTotal && basketData.subTotal) || 0
          }
          useAblePromoCodes={
            (basketData &&
              basketData.useAblePromoCodes &&
              basketData.useAblePromoCodes) ||
            null
          }
          deleteItem={deleteItem}
          item={item}
          useLocalePoints={useLocalePoints}
          addAlsoAdded={addAlsoAdded}
          handleCloseError={this.handleCloseError}
          loading={loading}
          newAddress={newAddress}
          addPromoCode={addPromoCode}
          orderUid={orderUid}
          pointsEarned={pointsEarned}
          submitted={submitted}
        />
      );
    }
  };
  render() {
    return this.renderSelectedPage();
  }
}

export default withRouter(CheckOutProducts);
